import React from 'react';

const Admin = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>
      {/* Admin dashboard content will be added here */}
    </div>
  );
};

export default Admin; 